import { useState } from 'react';
import { applyTheme, loadTheme, saveTheme, type Theme } from '../lib/dark-mode';

/**
 * Sun / moon button. Top-right of the viewport, just under the navigation
 * controls.
 */
export function DarkModeToggle() {
  const [theme, setTheme] = useState<Theme>(() => loadTheme());

  const toggle = () => {
    const next: Theme = theme === 'dark' ? 'light' : 'dark';
    setTheme(next);
    saveTheme(next);
    applyTheme(next);
  };

  const isDark = theme === 'dark';
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="dark-mode-toggle"
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-pressed={isDark}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      style={{
        position: 'absolute',
        top: 'var(--space-3)',
        right: 'calc(var(--space-3) + 36px + var(--space-1))',
        zIndex: 19,
        width: 36,
        height: 36,
        borderRadius: 'var(--radius-md)',
        background: 'var(--surface-raised)',
        border: '1px solid var(--border)',
        boxShadow: 'var(--shadow-card)',
        color: 'var(--text-headline)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {isDark ? (
        <svg
          width={18}
          height={18}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={1.75}
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          focusable="false"
        >
          <circle cx="12" cy="12" r="4" />
          <path d="M12 3v1.8M12 19.2V21M5.2 5.2l1.3 1.3M17.5 17.5l1.3 1.3M3 12h1.8M19.2 12H21M5.2 18.8l1.3-1.3M17.5 6.5l1.3-1.3" />
        </svg>
      ) : (
        <svg
          width={18}
          height={18}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={1.75}
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          focusable="false"
        >
          <path d="M21 12.8A9 9 0 1 1 11.2 3 7 7 0 0 0 21 12.8z" />
        </svg>
      )}
    </button>
  );
}
